import { createSelector } from '@ngrx/store';
import { CAAction } from '../actions';
import { State } from '../reducers/index';
import { DataListState, INITIAL_DATA_LIST_STATE } from '../data-list.state';
import { ReducerStateFactory } from '../state-factory.reducer';
import { CustomerListDto } from '@careapp-group/ng-sdk-v2-new/model/customerListDto';
import { CustomerLists } from './customer-lists.actions';

class CustomerListsState extends ReducerStateFactory<CustomerListDto> {
  readonly initialState: DataListState<CustomerListDto> = INITIAL_DATA_LIST_STATE;

  constructor(actions) {
    super(actions);
  }

  public reducer(
    state = this.initialState,
    action: CAAction | any
  ): DataListState<CustomerListDto> {
    switch (action.type) {
      default:
        return <any>super.reducer(state, action);

      case CustomerLists.RequestPatchById.type: {
        const typedAction: ReturnType<typeof CustomerLists.RequestPatchById> = action;
        return {
          ...state,
          loadingEntities: {
            ...state.loadingEntities,
            [typedAction.customerListId]: true,
          },
        };
      }
      case CustomerLists.ResponseFailPatchById.type: {
        const typedAction: ReturnType<typeof CustomerLists.ResponseFailPatchById> = action;
        return {
          ...state,
          loadingEntities: {
            ...state.loadingEntities,
            [typedAction.id]: false,
          },
          error: typedAction.error,
        };
      }
      case CustomerLists.ResponseSuccessPatchById.type: {
        const typedAction: ReturnType<typeof CustomerLists.ResponseSuccessPatchById> = action;
        return {
          ...state,
          loadingEntities: {
            ...state.loadingEntities,
            [typedAction.payload.id]: false,
          },
          error: null,
          entities: {
            ...state.entities,
            [typedAction.payload.id]: typedAction.payload,
          },
        };
      }
    }
  }
}

export const state = new CustomerListsState(CustomerLists);

export function reducer(...args) {
  return state.reducer.apply(state, args);
}

export const createSelectors = (rootReducer) => ({
  getCustomerLists: createSelector(rootReducer, (rootState: State) =>
    rootState.customerLists.ids
      .filter((id) => rootState.customerLists.entities[id] != null)
      .map((id) => rootState.customerLists.entities[id])
  ),
});
